import request from '../../libs/request';

export default {
  getSlug: (category, siteId) => request(`api/v1/${siteId}/slug/url/categoria/${category}`).get(),

  getProducts: (queryParams, siteId, token) => request(`api/v2/${siteId}/search`).get({ queryParams, token }),
};
